import { elementPlusPlugin, vuetifyPlugin } from 'blackburn-components';
import { createApp } from 'vue';

import { GlobalWorkerOptions } from 'vue-pdf-embed/dist/index.essential.mjs';
import hasAccessByRole from '~/directives/hasAccessByRole';
import hasAccessDirective from '~/directives/hasAccessDirective';

import arcaneApiGatewayPlugin from '~/plugins/arcane-api-gateway';
import arcaneFastApiPlugin from '~/plugins/arcane-fast-api';
import auth0Client from '~/plugins/authClient';
import BlackburnComponents from '~/plugins/blackburn-components';
import conversationSubscriptionPlugin from '~/plugins/conversation-subscription';
import filterFormPlugin from '~/plugins/filter-form';
import i18n from '~/plugins/i18n';
import realtimePlugin from '~/plugins/realtime';

import { initializeTracking } from '~/composables/usePostHog';

import router from '~/router';

import ArcaneApi from '~/services/arcane-api';

import '~/assets/styles/global.css';
import '~/assets/styles/quill.css';
import '~/assets/styles/main.css';
import '~/assets/styles/blackburn-theme.scss';
import 'blackburn-components/dist/style.css';

import store from '~/store';
import App from './App.vue';
import notificationService from './plugins/notification-service';

GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

// add external stylesheet
const loadExternalCSS = (url) => {
  const link = document.createElement('link');
  link.href = url;
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

const init = () => {
  initializeTracking();

  const app = createApp(App);

  const stage = import.meta.env.VUE_APP_STAGE;
  document.title = stage && stage !== 'PROD' ? `Arcane (${stage})` : 'Arcane';

  loadExternalCSS(
    `https://d1azc1qln24ryf.cloudfront.net/214395/Blackburn/style.css?${import.meta.env.BUILDKITE_BUILD_NUMBER}`,
  );
  app.use(vuetifyPlugin);
  app.use(elementPlusPlugin);
  app.use(BlackburnComponents);
  app.use(router);
  app.use(auth0Client);
  app.use(i18n);
  app.use(store);
  app.use(arcaneApiGatewayPlugin);
  app.use(arcaneFastApiPlugin);
  app.use(notificationService);
  app.use(realtimePlugin);
  app.use(filterFormPlugin);
  app.use(conversationSubscriptionPlugin);

  // TODO this will be deleted in the future as all the resources will be accessed within API Gateway
  const arcaneApi = ArcaneApi.getInstance(store);
  app.provide('arcaneApi', arcaneApi);

  // Register the directive globally
  app.directive('has-access', hasAccessDirective);
  app.directive('has-access-by-role', hasAccessByRole);

  app.mount('#app');
};

init();
